<template>
  <div>
    <ContentWithImage src="ops" image-order="1" image-order-sm="1" margin="50px 0">
      <text-container>
        <h2 class="h1" v-html="$t(`ops.title`)"/>
        <p v-html="$t(`ops.text`)"/>
        <b-row class="w-100 mb-3">
          <b-col class="browser">
            <img src="@/assets/chrome.png">
            <p>Chrome</p>
          </b-col>
          <b-col class="browser">
            <img src="@/assets/fire-fox.png">
            <p>Firefox</p>
          </b-col>
          <b-col class="browser">
            <img src="@/assets/edge.png">
            <p>Edge</p>
          </b-col>
        </b-row>
        <b-btn class="mt-2" variant="primary" to="/">
          {{$t(`ops.btn`)}}
        </b-btn>
      </text-container>
    </ContentWithImage>
    <div class="d-flex justify-content-end mb-5">
      <img src="@/assets/lotus.svg">
    </div>
  </div>
</template>

<script>
import { ContentWithImage } from '@/components/ui'

export default {
  name: 'Oooops',
  components: { ContentWithImage }
}
</script>

<style lang="sass" scoped>
button
  min-width: 140px

.browser
  display: flex
  flex-direction: column
  height: 100%
  text-align: center

  img
    margin: auto

  p
    margin-top: auto
    margin-bottom: 0
</style>



// WEBPACK FOOTER //
// src/components/errors/Oooops.vue